import { BeatResolution } from '@arpeggi/shared'
import { Instance, types } from 'mobx-state-tree'
import { ForDirectExtend } from '../../../../features/mobx'
import {
  INoteCollectionStore,
  NoteCollectionStore
} from '../../../stores/song/loop/NoteCollectionStore'
import { DrumSubLoopStore } from './DrumSubLoopStore'

const _DrumLoopStore = types
  .model({
    subLoops: types.array(DrumSubLoopStore)
  })
  .views((self) => ({
    // Essentially just combines all of the note collections for drums into a single collection
    // where the range of notes is equivalent to a row index -- the notes in this can't be trusted
    // for playback, but can be trusted for ordinality
    get condensedNotesForVisualization(): INoteCollectionStore {
      const noteCollection = NoteCollectionStore.create()
      self.subLoops.forEach((subLoop, subLoopIndex) => {
        subLoop.notes.notes.forEach((note) => {
          noteCollection.addNote({
            start: note.start,
            duration: note.duration,
            note: subLoopIndex
          })
        })
      })
      return noteCollection
    }
  }))
  .actions((self) => {
    function initialize(resolutions: BeatResolution[]) {
      resolutions.forEach((resolution) => {
        const drumSubLoop = DrumSubLoopStore.create()
        drumSubLoop.initialize(resolution)
        self.subLoops.push(drumSubLoop)
      })
    }
    function fromGenesis(partsAndResolutions: any) {
      partsAndResolutions.forEach(({ part, res }) => {
        const subloop = DrumSubLoopStore.create()
        subloop.fromGenesis(part, res)
        self.subLoops.push(subloop)
      })
    }
    return {
      initialize,
      fromGenesis
    }
  })

interface DrumLoopStoreType extends ForDirectExtend<typeof _DrumLoopStore> {}
export const DrumLoopStore: DrumLoopStoreType = _DrumLoopStore

export interface IDrumLoopStore extends ForDirectExtend<Instance<typeof DrumLoopStore>> {}
